import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import React from 'react';
import './index.less.js';

var Error = function Error(props) {
  var _a = props.errors,
    errors = _a === void 0 ? [] : _a;
  return /*#__PURE__*/React.createElement(React.Fragment, null, errors.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "ti-form-item-error"
  }, errors.map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      key: x
    }, x);
  })) : null);
};

export { Error as default };
